import { render, staticRenderFns } from "./OCTtlSub.html?vue&type=template&id=41202d24&scoped=true&"
import script from "./OCTtlSub.ts?vue&type=script&lang=ts&"
export * from "./OCTtlSub.ts?vue&type=script&lang=ts&"
import style0 from "./OCTtlSub.css?vue&type=style&index=0&id=41202d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41202d24",
  null
  
)

export default component.exports